import React, { useState, useRef, useEffect } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Seccion from 'components/Modificaciones/Seccion'

function Inicio() {
	
	// render
	return (
		<Container fluid id="seccion-inicio" className="vh-100">
			<Row className="d-flex no-gutters">
				<Col className="mt-2">
					<h1>Ejemplo de modificaciones de sección "Inicio"</h1>
					<hr />
					<Seccion
						nombreSeccion="inicio"
					/>
				</Col>
			</Row>
		</Container>
	)
}

export default Inicio